import { useCallback, type ChangeEvent } from 'react'

import type { ActivitySummaryTab } from '../../../typings'
import { useActivitySummaryContext } from '../../../context'
import { setActivitySummaryTabActionCreator as setTab } from '../../../state'

export function useHandlers() {
  const [, dispatch] = useActivitySummaryContext()

  const onChangeTab = useCallback(
    (_e: ChangeEvent<unknown>, value: ActivitySummaryTab) =>
      dispatch(setTab(value)),
    [dispatch],
  )

  return {
    onChangeTab,
  }
}
